import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

import { fetchMessages } from "./fetch-messages";
import type { Messages } from "./messages";
import { readRouteMessages, rememberHydratedMessages } from "./route-message-cache";

export async function getMessagesForRoute(locale: ViewerLocale): Promise<Messages> {
  if (typeof window !== "undefined") {
    const cached = readRouteMessages(locale);
    if (cached) return cached;
  }

  const result = await fetchMessages({ data: locale });
  if (typeof window !== "undefined") {
    rememberHydratedMessages(locale, result.messages);
  }
  return result.messages;
}
